<template>
<div class="messenger-wrapper" :style="{ height: height }">
    <!-- Chat history -->
    <vue-perfect-scrollbar class="chat-history--scrollbar" ref="chat_scroll" :settings="scrollbar_settings">
        <div class="chat-messages-list">
            <template v-for="item in comments">
                <div
                    :key="item.ID"
                    :class="['chat-row', item.UserName == myName ? 'chat-row--mine' : 'chat-row--other', item.Type === 2 ? 'chat-row--private' : '']"
                >
                    <!-- Avatar phía trái (người khác) -->
                    <div class="chat-avatar" v-if="item.UserName != myName">
                        <img :src="item.RoleType | comment_avatar" class="avatar-img" />
                    </div>

                    <div class="chat-bubble-group">
                        <div class="chat-sender-name" v-if="item.UserName != myName">
                            {{ item.UserName || item.CustomerName || '' }}
                        </div>
                        <div class="chat-bubble-container">
                            <div :class="['chat-bubble', item.UserName == myName ? 'bubble--mine' : 'bubble--other']">
                                <span v-if="!isImage(item.Comment)">{{ item.Comment }}</span>
                                <span v-else>
                                    <img :src="item.Comment" class="chat-image" @click="showGallery(item.Comment)" />
                                </span>
                            </div>
                            <button v-if="isAdmin" class="delete-msg-btn" type="button" @click.stop.prevent="onDeleteComment(item.ID)" title="Xóa tin nhắn">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </div>
                        <div class="chat-time">{{ formatTime(item.CreatedDate) }}</div>
                    </div>

                    <!-- Avatar phía phải (mình) -->
                    <div class="chat-avatar" v-if="item.UserName == myName">
                        <img :src="item.RoleType | comment_avatar" class="avatar-img" />
                    </div>
                </div>
            </template>
        </div>
    </vue-perfect-scrollbar>

    <gallery :images="galleryImages" :index="galleryIndex" @close="galleryIndex = null"></gallery>

    <!-- Input bar kiểu Messenger -->
    <div class="messenger-input-bar">
        <div class="input-row">
            <!-- Chọn khu vực gửi kiểu native select gọn gàng -->
            <select class="area-native-select" v-model="selectedArea">
                <option v-for="area in areas" :key="area.value" :value="area.value">
                    {{ area.name }}
                </option>
            </select>

            <!-- Icon chọn ảnh -->
            <button class="action-btn" type="button" @click="triggerImageUpload" :disabled="uploading" title="Gửi ảnh">
                <i class="fa fa-image" aria-hidden="true"></i>
            </button>

            <!-- Ô nhập text -->
            <div class="input-bubble-wrapper">
                <input
                    ref="textInput"
                    class="input-bubble"
                    type="text"
                    v-model="message"
                    placeholder="Aa"
                    @keyup.enter="onSendMessage"
                    @paste="onPaste"
                    :disabled="uploading"
                />
            </div>

            <!-- Icon gửi -->
            <button
                class="action-btn send-btn"
                type="button"
                @click="onSendMessage"
                :disabled="uploading"
                :class="{ 'send-btn--active': message.length > 0 }"
                title="Gửi tin nhắn"
            >
                <i class="fa fa-paper-plane" aria-hidden="true"></i>
            </button>
        </div>

        <input type="file" ref="imageUploader" style="display: none" @change="onImageSelected" accept="image/*" />

        <!-- Upload progress -->
        <div v-if="uploading" class="upload-progress">
            <v-progress-linear indeterminate color="#0084ff" height="3" rounded></v-progress-linear>
        </div>
    </div>
</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import VueGallery from "vue-gallery";
import moment from "moment"
import configs from '@/configs'
import _ from "lodash";
import {
    mapState
} from "vuex";
import {
    comment_avatar,
    comment_type,
    comment_type_color,
} from "@/commons/hpod";

export default {
    name: 'message-box',
    filters: {
        comment_type,
        comment_type_color,
        comment_avatar,
    },
    components: {
        VuePerfectScrollbar,
        gallery: VueGallery
    },
    props: {
        orderId: {
            type: Number,
            default: 0
        },
        orderType: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: "700px"
        }
    },
    data() {
        return {
            message: "",
            timer: "",
            selectedArea: 2,
            scrollbar_settings: {
               wheelPropagation: true
            },
            uploading: false,
            galleryImages: [],
            galleryIndex: null
        }
    },
    computed: {
        ...mapState("orderComment", {
            comments: "all"
        }),
        myName() {
            return this.$store.state.authentication.user.username;
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        storeTQRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
        areas() {
            // return this.storeVNRole || this.storeTQRole ? _.find(configs.COMMENT_TYPE, {value: 2}) : configs.COMMENT_TYPE;
            return configs.COMMENT_TYPE;
        },
        isAdmin() {
            const user = this.$store.state.authentication.user;
            return user && (user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        }
    },
    watch: {
        orderId() {
            this.fetchData();
        },
        comments() {
            this.scrollToEnd();
        }
    },
    methods: {
        todayMessage(createTime) {
            return moment(createTime).startOf('day').isSame(moment().startOf('day'));
        },
        formatTime(createTime) {
            return moment(createTime).format("DD/MM/YYYY HH:mm");
        },
        scrollToEnd() {
            setTimeout(() => {
                const container = this.$el.querySelector('.ps-container');
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            }, 0);
        },
        fetchData: _.debounce(function () {
            this.$store.dispatch("orderComment/getOrderCommentList", {id: this.orderId, type: this.orderType});
        }, 1000, {
            'leading': true,
            'trailing': false
        }),
        onSendMessage() {
            if(this.message != "") {
                this.$store.dispatch("orderComment/putOrderComment", {
                    'OrderID': this.orderId,
                    'Comment': this.message,
                    'Status': 0,
                    'Type': this.selectedArea,
                    'OrderType': this.orderType !== '' ? this.orderType : null,
                    'UserID': this.$store.state.authentication.user.userid
                });
                this.message = "";
                this.scrollToEnd();
            }
        },
        getTitle(user_name, send_time) {
            return "<span class='text--primary font-weight-bold'>"+user_name+"</span>: " + moment(send_time).format("DD-MM-YYYY HH:mm:ss")
        },
        isImage(text) {
            if (!text || typeof text !== 'string') return false;
            const urlWithoutParams = text.split('?')[0].split('#')[0];
            return (
                text.startsWith('http') &&
                /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(urlWithoutParams)
            );
        },
        triggerImageUpload() {
            this.$refs.imageUploader.click();
        },
        onImageSelected(e) {
            const file = e.target.files[0];
            if (!file) return;
            this.uploadImageFile(file);
            this.$refs.imageUploader.value = '';
        },
        onPaste(e) {
            const items = (e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData)).items;
            for (let index in items) {
                const item = items[index];
                if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
                    const blob = item.getAsFile();
                    this.uploadImageFile(blob);
                    e.preventDefault();
                }
            }
        },
        uploadImageFile(file) {
            this.uploading = true;
            let formData = new FormData();
            formData.append('file', file);
            this.$http.post(`${configs.API || ''}/admin/api/upload/r2/`, formData, {
                headers: { "Authorization": "Bearer " + this.$store.state.authentication.token }
            }).then(res => {
                this.uploading = false;
                if (res.data.status === 200 && res.data.data && res.data.data.url) {
                    this.$store.dispatch("orderComment/putOrderComment", {
                        'OrderID': this.orderId,
                        'Comment': res.data.data.url,
                        'Status': 0,
                        'Type': this.selectedArea,
                        'OrderType': this.orderType !== '' ? this.orderType : null,
                        'UserID': this.$store.state.authentication.user.userid
                    });
                    this.scrollToEnd();
                } else {
                    window.getApp.$emit('SHOW_NOTICE', "Upload thất bại: " + (res.data.message || res.data.error || ''), 'error');
                }
            }).catch(err => {
                this.uploading = false;
                window.getApp.$emit('SHOW_NOTICE', "Lỗi kết nối khi upload ảnh.", 'error');
            });
        },
        showGallery(clickedUrl) {
            const list = [];
            this.comments.forEach(item => {
                if (this.isImage(item.Comment)) {
                    list.push(item.Comment);
                }
            });
            const idx = list.indexOf(clickedUrl);
            this.galleryImages = list;
            this.galleryIndex = idx >= 0 ? idx : 0;
        },
        onDeleteComment(commentId) {
            if (confirm("Bạn có chắc chắn muốn xóa tin nhắn này?")) {
                this.$store.dispatch("orderComment/deleteOrderComment", {
                    ID: commentId,
                    OrderID: this.orderId,
                    OrderType: this.orderType
                });
            }
        }
    },
    mounted() {
        this.selectedArea = 2;
        this.fetchData();
    },
    created() {
        this.timer = setInterval(this.fetchData, 1000*configs.SYSTEM_CONFIG.notification_time);
    },
    destroyed() {
        clearInterval(this.timer);
    }
}
</script>

<style scoped>
/* === Wrapper === */
.messenger-wrapper {
    display: flex;
    flex-direction: column;
    height: 700px;
    background: #f0f2f5;
    border: 1px solid #e4e6eb;
    border-radius: 12px;
    overflow: hidden;
}

/* === Chat scrollable area === */
.chat-history--scrollbar {
    flex: 1;
    overflow-y: auto;
    background: #ffffff;
}

.chat-messages-list {
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* === Message row === */
.chat-row {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    max-width: 100%;
}

.chat-row--mine {
    flex-direction: row-reverse;
}

.chat-row--other {
    flex-direction: row;
}

.chat-row--private {
    background: rgb(255 124 124 / 49%);
    border-radius: 12px;
    padding: 8px;
}

/* === Avatar === */
.chat-avatar {
    flex-shrink: 0;
}

.avatar-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #e0e0e0;
}

/* === Bubble group === */
.chat-bubble-group {
    display: flex;
    flex-direction: column;
    max-width: 70%;
}

.chat-row--mine .chat-bubble-group {
    align-items: flex-end;
}

.chat-row--other .chat-bubble-group {
    align-items: flex-start;
}

/* === Sender name === */
.chat-sender-name {
    font-size: 11px;
    color: #65676b;
    font-weight: 600;
    margin-bottom: 2px;
    padding-left: 4px;
}

/* === Bubble === */
.chat-bubble {
    padding: 8px 14px;
    border-radius: 18px;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
    max-width: 100%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.bubble--mine {
    background: #0084ff;
    color: #ffffff;
    border-bottom-right-radius: 4px;
}

.bubble--other {
    background: #f0f2f5;
    color: #050505;
    border-bottom-left-radius: 4px;
}

/* === Time === */
.chat-time {
    font-size: 10px;
    color: #8a8d91;
    margin-top: 3px;
    padding: 0 4px;
}

/* === Chat image === */
.chat-image {
    max-width: 220px;
    max-height: 220px;
    border-radius: 12px;
    display: block;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: opacity 0.2s;
}

.chat-image:hover {
    opacity: 0.9;
}

/* === Input bar === */
.messenger-input-bar {
    background: #ffffff;
    border-top: 1px solid #e4e6eb;
    padding: 10px 16px;
    position: relative;
}

.input-row {
    display: flex;
    align-items: center;
    background: #f0f2f5;
    border-radius: 20px;
    padding: 4px 8px;
    gap: 8px;
}

/* === Area native select === */
.area-native-select {
    flex-shrink: 0;
    font-size: 12px;
    color: #0084ff;
    font-weight: 600;
    background: #e4e6eb;
    border: none;
    border-radius: 14px;
    outline: none;
    padding: 4px 8px;
    cursor: pointer;
    margin-left: 2px;
    height: 28px;
    transition: background 0.15s;
}

.area-native-select:hover {
    background: #d8dadf;
}

.area-native-select option {
    background: #ffffff;
    color: #050505;
}

/* === Icon buttons === */
.action-btn {
    background: none;
    border: none;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0084ff;
    font-size: 16px;
    flex-shrink: 0;
    transition: background 0.15s;
    outline: none;
}

.action-btn:hover:not(:disabled) {
    background: #e4e6eb;
}

.action-btn:disabled {
    color: #b0b3b8;
    cursor: not-allowed;
}

.send-btn {
    color: #b0b3b8;
}

.send-btn--active {
    color: #0084ff;
}

/* === Text input === */
.input-bubble-wrapper {
    flex: 1;
    min-width: 0;
}

.input-bubble {
    width: 100%;
    border: none;
    background: transparent;
    outline: none;
    font-size: 14px;
    color: #050505;
    padding: 6px 4px;
    line-height: 1.4;
}

.input-bubble::placeholder {
    color: #8a8d91;
}

.input-bubble:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* === Upload progress === */
.upload-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
.chat-bubble-container {
    display: flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
}
.chat-row--mine .chat-bubble-container {
    flex-direction: row-reverse;
}
.delete-msg-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #050505;
    opacity: 0.1;
    transition: opacity 0.2s;
    padding: 4px;
    border-radius: 50%;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}
.delete-msg-btn:hover {
    background: #fed7d7;
    opacity: 1 !important;
}
.chat-bubble-container:hover .delete-msg-btn {
    opacity: 1;
}
</style>
